// exportUtils.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import _ from "lodash";

// Function to export data as CSV
// Function to export data as CSV
export const exportCSV = (value, column,fileName) => {
    if (!value || !column || !Array.isArray(value) || !Array.isArray(column)) return;

    // Extract headers from columns
    const headers = column.map(col => col.label.trim()).join(",");

    // Extract rows from values
    const rows = value.map(item =>
        column.map(col => _.get(item, col.name, "N/A")).join(",")
    ).join("\n");

    // Combine headers and rows
    const csvContent = `${headers}\n${rows}`;

    // Create a downloadable CSV file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.csv`;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

// Function to export data as Excel
export const exportExcel = (value, column,fileName) => {
    const exportData = value.map(item => {
        const row = {};
        column.forEach(col => {
            const label = col.label?.trim();
            const field = col.name;
            const cellValue = _.get(item, field);
            row[label] = cellValue !== undefined && cellValue !== null ? cellValue : "N/A";
        });
        return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${fileName}`);
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

// Function to export data as PDF
export const exportPdf = (value, column,fileName) => {
    const doc = new jsPDF();

    const headers = column.map(col => col.label.trim());

    const rows = value.map(item =>
        column.map(col => {
            const cellValue = _.get(item, col.name);
            return cellValue !== undefined && cellValue !== null ? cellValue : "N/A";
        })
    );

    autoTable(doc, {
        head: [headers],
        body: rows,
        startY: 20,
        theme: 'striped',
        headStyles: { fillColor: [41, 128, 185] }
    });

    doc.save(`${fileName}.pdf`);
};
